import { BehaviourDetail } from './types';

// Display documentation for the defaults in anomalies/analysis.ts and detect.ts.
// These describe automatic calculation; they must not be written into blank override fields.
export default function StandardSettings({ detail }: { detail: BehaviourDetail }) {
  const gsm = detail.plant.deviceFamily === 'GSM';
  const onOff = (value: boolean) => (value ? 'Til' : 'Fra');
  return (
    <section className="behaviour-standards" aria-label="Standardindstillinger">
      <h3>Standardindstillinger</h3>
      <p>Dette bruges uden egne forventninger. Tomme felter beholder automatisk beregning.</p>
      <dl>
        <div>
          <dt>Målinger</dt>
          <dd>{gsm ? 'Vand og binder' : 'Niveau'} · alle er med, hvis intet vælges</dd>
        </div>
        <div>
          <dt>Planlagt kontrol</dt>
          <dd>Hver time · kan sættes på pause</dd>
        </div>
        {gsm ? (
          <>
            <div>
              <dt>Forbrugsperiode</dt>
              <dd>Pr. døgn (liter/døgn)</dd>
            </div>
            <div>
              <dt>Normalforbrug</dt>
              <dd>Beregnes fra anlæggets historik · ingen fast literværdi</dd>
            </div>
            <div>
              <dt>Vand · automatisk margin</dt>
              <dd>Største af ±75 %, historisk variation og ±500 liter/døgn</dd>
            </div>
            <div>
              <dt>Binder · automatisk margin</dt>
              <dd>Største af ±75 %, historisk variation og ±5 liter/døgn</dd>
            </div>
            <div>
              <dt>Drift / ugedage</dt>
              <dd>
                Sammenlignelig drift: {onOff(detail.defaults.compareOperatingPeriods)} · ugedage:{' '}
                {onOff(detail.defaults.compareWeekdays)}
              </dd>
            </div>
            <div>
              <dt>Driftssignal / plan</dt>
              <dd>
                Pumpetid: {onOff(detail.defaults.usePumpRuntime)} ved gyldige data · ingen
                driftsplan
              </dd>
            </div>
          </>
        ) : (
          <>
            <div>
              <dt>Niveauspring</dt>
              <dd>Mindst 20 cm inden for 120 minutter</dd>
            </div>
            <div>
              <dt>Gentagne spring</dt>
              <dd>Yderligere spring udelades i 60 minutter efter første hændelse</dd>
            </div>
          </>
        )}
      </dl>
      {gsm && (
        <details>
          <summary>Sådan beregnes det automatiske interval</summary>
          <p>
            Midtpunktet er medianen af op til 21 tidligere måleperioder fra de seneste 28 dage. Der
            kræves mindst 7 tidligere perioder. Uden nok historik vises intet automatisk interval.
          </p>
          <p>
            Den statistiske margin er 3,5 × robust spredning (MAD / 0,6745). Den største af denne
            margin, 75 % af midtpunktet og målingens mindstemargin bruges på begge sider. Den nedre
            grænse er mindst nul.
          </p>
          <p>
            Angiver du selv procent eller liter, erstatter din margin hele den automatiske margin.
            Er kun ét af de to felter udfyldt, bruges kun dét; er begge udfyldt, bruges den største
            margin.
          </p>
        </details>
      )}
    </section>
  );
}
